"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

require('./chunk-NESC3UD7.js');

require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

var _jsxruntime = require('react/jsx-runtime');

var o = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "TwitterIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M24.5331 9.98436C24.5483 10.2031 24.5483 10.4219 24.5483 10.6406C24.5483 17.3125 19.5991 25 10.5533 25C7.7665 25 5.17768 24.1718 3 22.7344C3.39595 22.7812 3.77663 22.7969 4.18782 22.7969C6.48728 22.7969 8.60407 22 10.2944 20.6406C8.13199 20.5938 6.31979 19.1406 5.69542 17.1406C6.00001 17.1875 6.30456 17.2187 6.62439 17.2187C7.066 17.2187 7.50766 17.1562 7.9188 17.0469C5.66499 16.5781 3.97458 14.5469 3.97458 12.0937V12.0313C4.62938 12.4063 5.39087 12.6406 6.19792 12.6719C4.87304 11.7656 4.00505 10.2187 4.00505 8.46871C4.00505 7.53123 4.24866 6.67186 4.67508 5.92185C7.09642 8.98435 10.736 10.9843 14.8172 11.2031C14.7411 10.8281 14.6954 10.4375 14.6954 10.0469C14.6954 7.2656 16.8883 5 19.6142 5C21.0304 5 22.3096 5.60937 23.2081 6.59375C24.3198 6.37501 25.3858 5.95311 26.33 5.375C25.9644 6.5469 25.1878 7.53128 24.1675 8.15624C25.1574 8.04691 26.1168 7.7656 27 7.37502C26.3301 8.37498 25.4924 9.26557 24.5331 9.98436Z"
  }),
  svgElements: ["path"]
});

exports.TwitterIconMedium = o;